"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.access.denied.title': '拒绝访问',
    'reports.access.denied.enterprise': '企业用户无法访问成本报告。',
    'reports.access.denied.general': '只有上级用户和超级管理员才能访问成本报告。',
};
